module.exports = __webpack_public_path__ + "static/media/double-chevron.acdcfc8b.svg";